let lenisInstance = null;

export const setLenis = (lenis) => {
  lenisInstance = lenis;
};

export const scrollToId = (target) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, {
      duration: 1.5,
      easing: (t) => 1 - Math.pow(1 - t, 4),
    });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
